import { animate, inView } from "motion";

document.addEventListener('DOMContentLoaded', () => {
    const containers = document.querySelectorAll('.block-container');
    const isMobile = window.innerWidth < 768;

    const animationPresets = {
        'fade-up':   { transform: 'translateY(30px)',  axis: 'Y' },
        'fade-down': { transform: 'translateY(-60px)', axis: 'Y' },
        'fade-left': { transform: 'translateX(60px)',  axis: 'X' },
        'fade-right':{ transform: 'translateX(-60px)', axis: 'X' },
        'fade-in':   { transform: 'none', axis: null },
    };

    const getTransformValues = (preset) => {
        if (!preset) return ['none', 'none'];
        return preset.axis
            ? [preset.transform, `translate${preset.axis}(0)`]
            : ['none', 'none'];
    };

    const isInsideTabContent = (el) => {
        return el.closest('.component-tab__content') !== null;
    };

    const animationRules = [
        {
            selector: '.wp-block-columns',
            children: [
                { selector: ':scope > .wp-block-column:first-child', desktop: 'fade-right', mobile: 'fade-right' },
                { selector: ':scope > .wp-block-column:last-child',  desktop: 'fade-left', mobile: 'fade-left' }
            ]
        },
        {
            selector: '.wp-block-group',
            desktop: 'fade-in',
            mobile: 'fade-in'
        },
        {
            selector: '.component-component-media__grid',
            children: [
                { selector: ':scope > *:first-child', desktop: 'fade-right', mobile: 'fade-right' },
                { selector: ':scope > *:last-child', desktop: 'fade-left', mobile: 'fade-left' }
            ]
        },
        {
            selector: '.component-split-media__grid',
            children: [
                { selector: ':scope > *:first-child', desktop: 'fade-right', mobile: 'fade-right' },
                { selector: ':scope > *:last-child', desktop: 'fade-left', mobile: 'fade-left' }
            ]
        },
        {
            selector: '.component-newsletter__content',
            children: [
                { selector: ':scope > *:first-child', desktop: 'fade-right', mobile: 'fade-right' },
                { selector: ':scope > *:last-child', desktop: 'fade-left', mobile: 'fade-left' }
            ]
        },
        {
            selector: '.component-accordion__accordion',
            desktop:  'fade-up',
            mobile:   'fade-up'
        },
        {
            selector: '.component-icon',
            desktop:  'fade-up',
            mobile:   'fade-up'
        },
        {
            selector: '.component-swiper-cards__swiper',
            mobile: 'fade-in',
            children: [
                { selector: '.swiper-wrapper > .component-swiper-cards__card', desktop: 'fade-up' }
            ]
        },
        {
            selector: '.component-simple-cards',
            mobile: 'fade-up',
            children: [
                { selector: '.component-simple-cards__card', desktop: 'fade-up' }
            ]
        },
        {
            selector: '.component-tab-container__tabs',
            mobile: 'fade-in',
            children: [
                { selector: '.component-tab__heading', desktop: 'fade-in' }
            ]
        },
        {
            selector: '.component-tab__inner',
            desktop: 'fade-in',
            mobile: 'fade-in'
        }
    ];

    containers.forEach(container => {
        animationRules.forEach(rule => {
            const elements = container.querySelectorAll(rule.selector);

            elements.forEach((el, parentIndex) => {
                if (isInsideTabContent(el)) return; // 🚫 Skip animations inside tab content

                let childrenApplicable = false;

                // Determine if we should animate children for the current device
                if (rule.children && rule.children.some(child => {
                    return (isMobile ? child.mobile : child.desktop) !== undefined;
                })) {
                    childrenApplicable = true;
                }

                // If children are applicable, animate them
                if (childrenApplicable) {
                    rule.children.forEach(childRule => {
                        const key = isMobile ? childRule.mobile : childRule.desktop;
                        const preset = animationPresets[key];
                        if (!key || !preset) return;

                        const childElements = el.querySelectorAll(childRule.selector);
                        childElements.forEach((childEl, i) => {
                            if (childEl.hasAttribute('data-motion')) return;
                            if (isInsideTabContent(childEl)) return; // 🚫 Skip if child inside tab content
                            childEl.setAttribute('data-motion', 'true');

                            inView(childEl, () => {
                                animate(childEl, {
                                    opacity: [0, 1],
                                    transform: getTransformValues(preset),
                                }, {
                                    duration: 0.9,
                                    delay: 0.125 * i,
                                    once: true
                                });
                            }, {
                                amount: 0.2
                            });
                        });
                    });

                    return; // ✅ Skip main selector animation if children were animated
                }

                // Otherwise, animate the main selector if defined
                const key = isMobile ? rule.mobile : rule.desktop;
                const preset = animationPresets[key];
                if (!key || !preset) return;

                if (el.hasAttribute('data-motion')) return;
                el.setAttribute('data-motion', 'true');

                inView(el, () => {
                    animate(el, {
                        opacity: [0, 1],
                        transform: getTransformValues(preset),
                    }, {
                        duration: 0.9,
                        delay: 0.125 * parentIndex,
                        once: true
                    });
                }, {
                    amount: 0.2
                });
            });
        });
    });
});